// =====================
// modals.js
// Contains all modal-related JS, event listeners, conversation history logic, etc.
// (This code was previously inline in index.html. No changes other than removing <script> tags.)
// =====================

document.addEventListener('DOMContentLoaded', function() {
  // Function to open history modal with a specific conversation
  window.openHistoryModalWithConversation = function(conversationId) {
    const historyModal = document.getElementById('history-modal');
    const dashboardModal = document.getElementById('dashboard-modal');
    if (!historyModal) return;
    
    // Close the dashboard modal if it's open
    if (dashboardModal && dashboardModal.classList.contains('active')) {
      dashboardModal.classList.remove('active');
    }
    
    historyModal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scrolling behind modal
    
    // Always ensure history data is loaded
    if (!window.historyDataLoaded) {
      loadHistoryData()
        .then(() => {
          // After history data is loaded, display the specific conversation
          if (conversationId) {
            displayConversation(conversationId);
          }
        })
        .catch(err => {
          console.error('Error loading history data:', err);
        });
    } else {
      // If history data is already loaded, make sure local historyData is updated
      if (window.historyData) {
        historyData = window.historyData;
      }
      
      // Render the history list
      renderHistoryList();
      
      // Then display the specific conversation
      if (conversationId) {
        displayConversation(conversationId);
      }
    }
  };
  
  // About modal functionality
  const aboutModal = document.getElementById('about-modal');
  const aboutLink = document.getElementById('about-link');
  const closeAboutModal = document.getElementById('close-about-modal');
  const modalOverlay = aboutModal.querySelector('.modal-overlay');
  const slideMenu = document.getElementById('slide-menu');
  
  // Upgrade modal functionality
  const upgradeModal = document.getElementById('upgrade-modal');
  const upgradeLink = document.getElementById('upgrade-link');
  const closeUpgradeModal = document.getElementById('close-upgrade-modal');
  const upgradeModalOverlay = upgradeModal.querySelector('.modal-overlay');
  
  // History modal functionality
  const historyLink = document.getElementById('history-link');
  const historyModal = document.getElementById('history-modal');
  const closeHistoryModal = document.getElementById('close-history-modal');
  const historyModalOverlay = historyModal ? historyModal.querySelector('.modal-overlay') : null;
  
  // Login functionality
  const loginLink = document.querySelector('.slide-menu a[href="/login"]');
  if (loginLink) {
    loginLink.addEventListener('click', function(e) {
      e.preventDefault();
      // Close the slide menu before navigating
      if (slideMenu.classList.contains('open')) {
        slideMenu.classList.remove('open');
      }
      // Navigate to login page
      window.location.href = '/login';
    });
  }
  
  // View All History button functionality
  const viewAllHistoryBtn = document.getElementById('view-all-history');
  if (viewAllHistoryBtn && historyModal) {
    console.log('View All History button found:', viewAllHistoryBtn);
    viewAllHistoryBtn.addEventListener('click', function(e) {
      console.log('View All History button clicked');
      e.preventDefault();
      if (dashboardModal) {
        dashboardModal.classList.remove('active');
      }
      historyModal.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling
      console.log('History modal activated');
      // Always attempt to load history data to ensure it's properly loaded
      loadHistoryData()
        .then(() => {
          // Also set recentActivityProcessed so account modal knows data is ready
          window.recentActivityProcessed = true;
        })
        .catch(err => {
          console.error('Error loading history data:', err);
        });
    });
  }
  
  // Open about modal when About link is clicked (intercept if on homepage)
  if (aboutLink) {
    aboutLink.addEventListener('click', function(e) {
      // If we are on the homepage (has the about modal present), intercept and open modal
      if (aboutModal) {
        e.preventDefault();
        aboutModal.classList.add('active');
        document.body.style.overflow = 'hidden'; // Prevent scrolling behind modal
        // Close the slide menu when opening the modal
        if (slideMenu && slideMenu.classList.contains('open')) {
          slideMenu.classList.remove('open');
        }
      }
      // Else, let the link navigate to /about normally
    });
  }
  
  // Open upgrade modal when Upgrade link is clicked
  if (upgradeLink) {
    upgradeLink.addEventListener('click', function(e) {
      e.preventDefault();
      // Allow anonymous users to open the modal
      upgradeModal.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling behind modal
      
      // Close the slide menu when opening the modal
      if (slideMenu.classList.contains('open')) {
        slideMenu.classList.remove('open');
      }
    });
  }

  // Function to show the upgrade prompt for history
  function showHistoryUpgradePrompt() {
    // Check if the prompt already exists
    if (document.getElementById('history-upgrade-prompt')) {
      return;
    }
    const promptDiv = document.createElement('div');
    promptDiv.id = 'history-upgrade-prompt';
    promptDiv.className = 'history-upgrade-prompt'; // Use a specific class for styling

    promptDiv.innerHTML = `
      <div class="history-upgrade-content">
        <button class="close-prompt-btn">&times;</button>
        <h3><i class="fas fa-crown"></i> Access Full History with PRO</h3>
        <p>Upgrade to nunn.ai PRO to save and view your complete conversation history.</p>
        <button class="upgrade-prompt-btn">Upgrade to PRO</button>
      </div>
    `;
    document.body.appendChild(promptDiv);

    // Add event listeners
    const closeButton = promptDiv.querySelector('.close-prompt-btn');
    closeButton.addEventListener('click', () => {
      promptDiv.remove();
    });

    const upgradeButton = promptDiv.querySelector('.upgrade-prompt-btn');
    upgradeButton.addEventListener('click', () => {
      promptDiv.remove();
      // Open the main upgrade modal
      const upgradeModal = document.getElementById('upgrade-modal');
      if (upgradeModal) {
        upgradeModal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });

    // Add click outside listener
    promptDiv.addEventListener('click', function(e) {
        if (e.target === promptDiv) { // Check if the click is on the background overlay itself
            promptDiv.remove();
        }
    });


    // Fade in
    setTimeout(() => {
      promptDiv.classList.add('visible');
    }, 10);
  }
  
  // Open history modal when History link is clicked (or show upgrade prompt)
  if (historyLink) {
    console.log('History link found:', historyLink);
    historyLink.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('History link clicked');

      historyModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (slideMenu && slideMenu.classList.contains('open')) {
        slideMenu.classList.remove('open');
      }
      loadHistoryData();
    });
  }
  
  // Close about modal when X button is clicked
  closeAboutModal.addEventListener('click', function() {
    aboutModal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  });
  
  // Close upgrade modal when X button is clicked
  closeUpgradeModal.addEventListener('click', function() {
    upgradeModal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  });
  
  // Close history modal when X button is clicked
  if (closeHistoryModal) {
    closeHistoryModal.addEventListener('click', function() {
      historyModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });
  }
  
  // Close about modal when clicking on overlay
  modalOverlay.addEventListener('click', function() {
    aboutModal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  });
  
  // Close upgrade modal when clicking on overlay
  upgradeModalOverlay.addEventListener('click', function() {
    upgradeModal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  });
  
  // Close history modal when clicking on overlay
  if (historyModalOverlay) {
    historyModalOverlay.addEventListener('click', function() {
      historyModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });
  }
  
  // Tab navigation within the about modal
  const tabButtons = aboutModal.querySelectorAll('.tab-button');
  const tabContents = aboutModal.querySelectorAll('.tab-content');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Remove active class from all buttons and contents
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      
      // Add active class to clicked button and corresponding content
      button.classList.add('active');
      const tabId = button.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');
    });
  });

  // --- Blog byline: open About modal on name/avatar clicks ---
  function openAboutTab(tabId) {
    if (!aboutModal) return;
    aboutModal.classList.add('active');
    document.body.style.overflow = 'hidden';
    // Activate requested tab
    tabButtons.forEach(btn => btn.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('active'));
    const targetButton = aboutModal.querySelector(`.tab-button[data-tab="${tabId}"]`);
    const targetContent = document.getElementById(tabId);
    if (targetButton) targetButton.classList.add('active');
    if (targetContent) targetContent.classList.add('active');
    // Close slide menu if open
    if (slideMenu && slideMenu.classList.contains('open')) {
      slideMenu.classList.remove('open');
    }
  }

  // Delegate clicks for byline names and avatars
  document.addEventListener('click', function(e) {
    const authorLink = e.target.closest('.byline-author-link, .byline-avatar');
    if (!authorLink) return;
    const name = authorLink.getAttribute('data-author-name') || '';
    if (name.toLowerCase().includes('g. alexander nunn') || name.toLowerCase().includes('alexander nunn') || name.toLowerCase().includes('alex nunn')) {
      e.preventDefault();
      openAboutTab('about-creator'); // About the Author
      return;
    }
    // Non-Nunn names assumed to be team members → About The Team
    e.preventDefault();
    openAboutTab('about-team');
  });
  
  // Close modals with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (aboutModal.classList.contains('active')) {
        aboutModal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
      if (upgradeModal.classList.contains('active')) {
        upgradeModal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
      if (historyModal && historyModal.classList.contains('active')) {
        historyModal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
    }
  });
  
  // Connect Subscribe to PRO button in about modal to upgrade modal
  const aboutUpgradeBtn = document.getElementById('about-upgrade-btn');
  if (aboutUpgradeBtn) {
    aboutUpgradeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      // Allow anonymous users to open the modal
      // Close about modal
      aboutModal.classList.remove('active');
      
      // Open upgrade modal
      upgradeModal.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    });
  }
  
  // Menu toggle functionality
  const menuToggle = document.getElementById('menu-toggle');
  const closeMenu = document.getElementById('close-menu');
  
  // Open menu when hamburger is clicked
  menuToggle.addEventListener('click', function() {
    slideMenu.classList.add('open');
  });
  
  // Close menu when X button is clicked
  closeMenu.addEventListener('click', function() {
    slideMenu.classList.remove('open');
  });
  
  // Close menu when clicking outside
  document.addEventListener('click', function(event) {
    if (!slideMenu.contains(event.target) && !menuToggle.contains(event.target) && slideMenu.classList.contains('open')) {
      slideMenu.classList.remove('open');
    }
  });
  
  // Function to check if elements overlap
  function checkOverlap() {
    const notice = document.querySelector('.version-notice');
    const userNav = document.querySelector('.user-nav');
    
    if (!notice || !userNav) return;
    
    const noticeRect = notice.getBoundingClientRect();
    const userNavRect = userNav.getBoundingClientRect();
    
    // Check if there's horizontal overlap
    const horizontalOverlap = !(
      noticeRect.right < userNavRect.left || 
      noticeRect.left > userNavRect.right
    );
    
    // Check if there's vertical overlap
    const verticalOverlap = !(
      noticeRect.bottom < userNavRect.top || 
      noticeRect.top > userNavRect.bottom
    );
    
    // If both horizontal and vertical overlap, add the fade class
    if (horizontalOverlap && verticalOverlap) {
      notice.classList.add('fade');
    } else {
      notice.classList.remove('fade');
    }
  }
  
  // Check overlap on load and on resize
  checkOverlap();
  window.addEventListener('resize', checkOverlap);
  
  // Dashboard modal functionality
  const dashboardModal = document.getElementById('dashboard-modal');
  // Removed: const dashboardLink = document.querySelector('.profile-link'); - We'll use delegation
  const dashboardUpgradeLink = document.getElementById('dashboard-upgrade-link');

  // Make dashboardUpgradeLink globally available (dashboardLink removed)
  window.dashboardUpgradeLink = dashboardUpgradeLink;

  const closeDashboardModal = document.getElementById('close-dashboard-modal');
  const dashboardModalOverlay = dashboardModal.querySelector('.modal-overlay');
  const dashboardMenuItems = document.querySelectorAll('.dashboard-menu-item');
  const dashboardTabs = document.querySelectorAll('.dashboard-tab');

  // Use event delegation on the slide menu for the profile link
  if (slideMenu) {
    slideMenu.addEventListener('click', function(e) {
      // Check if the clicked element or its parent is the profile link
      const profileLink = e.target.closest('.profile-link');
      if (profileLink) {
        e.preventDefault();

        // Close slide menu if it's open
        if (slideMenu.classList.contains('open')) { // Check for 'open' class based on previous logic
           slideMenu.classList.remove('open');
        }

        // Show the dashboard modal
        dashboardModal.classList.add('active');
        document.body.style.overflow = 'hidden'; // Prevent scrolling

        // Process recent activity after modal is fully displayed
        // Ensure processRecentActivity is defined or available
        if (typeof processRecentActivity === 'function') {
            setTimeout(() => {
                processRecentActivity().catch(err => {
                    console.error('Error processing recent activity:', err);
                });
            }, 100);
        } else {
             console.error('processRecentActivity function not found');
        }
      }
    });
  }

  // Close dashboard modal when X button is clicked
  if (closeDashboardModal) {
    closeDashboardModal.addEventListener('click', function() {
      dashboardModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });
  }
  
  // Close dashboard modal when clicking on overlay
  if (dashboardModalOverlay) {
    dashboardModalOverlay.addEventListener('click', function() {
      dashboardModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });
  }
  
  // Add event listener for the dashboard modal tabs
  dashboardMenuItems.forEach(item => {
    item.addEventListener('click', function() {
      // Remove active class from all menu items and tabs
      dashboardMenuItems.forEach(menuItem => menuItem.classList.remove('active'));
      document.querySelectorAll('.dashboard-tab').forEach(tab => tab.classList.remove('active'));
      
      // Add active class to clicked menu item and corresponding tab
      this.classList.add('active');
      const tabId = this.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');
      
      // If this is the activity tab, always process recent activity
      if (tabId === 'activity-tab') {
        processRecentActivity().catch(err => {
          console.error('Error processing recent activity:', err);
        });
      }
    });
  });
  
  // Link dashboard upgrade button to upgrade modal
  if (window.dashboardUpgradeLink && upgradeModal) {
    window.dashboardUpgradeLink.addEventListener('click', function(e) {
      e.preventDefault();
      dashboardModal.classList.remove('active');
      upgradeModal.classList.add('active');
    });
  }

  // Update Escape key handler to include dashboard modal
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      if (aboutModal.classList.contains("active")) {
        aboutModal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
      if (upgradeModal.classList.contains('active')) {
        upgradeModal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
      if (historyModal && historyModal.classList.contains('active')) {
        historyModal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
      if (dashboardModal && dashboardModal.classList.contains('active')) {
        dashboardModal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
    }
  });
  
  // Add event listener for the upgrade nudge button
  const upgradeNudgeButton = document.getElementById('upgrade-nudge-button');
  if (upgradeNudgeButton) {
    upgradeNudgeButton.addEventListener('click', function(e) {
      e.preventDefault();
      // Allow anonymous users to open the modal
      const upgradeModal = document.getElementById('upgrade-modal');
      upgradeModal.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling behind modal
    });
  }
  
  // Function to update dynamic elements for logged-in users
  function updateDynamicElements(isLoggedIn) {
    // ... existing code ...
  }
  
  // History functionality
  let historyData = {};
  let currentConversationId = null;
  
  function loadHistoryData() {
    return new Promise((resolve, reject) => {
      fetch('/api/history')
        .then(response => response.json())
        .then(data => {
          historyData = data;
          window.historyData = data; // Make it globally available
          renderHistoryList();
          window.historyDataLoaded = true;
          
          // Set recentActivityProcessed to true so account modal knows activity is loaded
          window.recentActivityProcessed = true;
          
          // Add event listener for search input after data is loaded
          const searchInput = document.getElementById('history-search-input');
          if (searchInput) {
            searchInput.addEventListener('input', function() {
              filterHistoryList(this.value.toLowerCase());
            });
          }
          
          resolve(data);
        })
        .catch(error => {
          console.error('Error loading history data:', error);
          document.getElementById('history-list').innerHTML = `
            <div class="history-empty">
              <i class="fas fa-exclamation-circle"></i>
              <p>Unable to load history. Please try again later.</p>
            </div>
          `;
          reject(error);
        });
    });
  }
  
  function renderHistoryList() {
    const historyList = document.getElementById('history-list');
    if (!historyList) return;
    
    // Clear existing content
    historyList.innerHTML = '';
    
    // Check if we have any history data
    if (Object.keys(historyData).length === 0) {
      historyList.innerHTML = `
        <div class="history-empty">
          <i class="fas fa-search"></i>
          <p>No search history yet. Start by asking a question!</p>
        </div>
      `;
      return;
    }
    
    // First, group by conversation_id
    const conversationGroups = {};
    Object.keys(historyData).forEach(id => {
      const entry = historyData[id];
      const conversationId = entry.conversation_id || id;
      
      if (!conversationGroups[conversationId]) {
        conversationGroups[conversationId] = [];
      }
      conversationGroups[conversationId].push({
        id: id,
        entry: entry
      });
    });
    
    // Sort messages within each conversation by timestamp
    Object.keys(conversationGroups).forEach(conversationId => {
      conversationGroups[conversationId].sort((a, b) => {
        return new Date(a.entry.timestamp) - new Date(b.entry.timestamp);
      });
    });
    
    // Now group conversations by date using the timestamp of the first message
    const groupedByDate = {};
    Object.keys(conversationGroups).forEach(conversationId => {
      const conversation = conversationGroups[conversationId];
      const firstMessage = conversation[0];
      const date = new Date(firstMessage.entry.timestamp);
      const dateStr = date.toLocaleDateString();
      
      if (!groupedByDate[dateStr]) {
        groupedByDate[dateStr] = [];
      }
      
      // Remove the complete prefix including the colon from the first question
      const cleanQuestion = firstMessage.entry.question.replace(/^In the context of evidence law in the united states:\s*/i, '');
      firstMessage.entry.cleanQuestion = cleanQuestion;
      
      groupedByDate[dateStr].push({
        conversationId: conversationId,
        firstMessage: firstMessage,
        messageCount: conversation.length
      });
    });
    
    // Sort dates in descending order (newest first)
    const sortedDates = Object.keys(groupedByDate).sort((a, b) => {
      return new Date(b) - new Date(a);
    });
    
    // Create HTML for each date group
    sortedDates.forEach(dateStr => {
      const dateGroup = document.createElement('div');
      dateGroup.className = 'history-date-group';
      
      const dateHeader = document.createElement('div');
      dateHeader.className = 'history-date-header';
      dateHeader.textContent = formatDateHeader(dateStr);
      dateGroup.appendChild(dateHeader);
      
      // Sort conversations within each date (newest first)
      const sortedConversations = groupedByDate[dateStr].sort((a, b) => {
        return new Date(b.firstMessage.entry.timestamp) - new Date(a.firstMessage.entry.timestamp);
      });
      
      sortedConversations.forEach(conversation => {
        const firstMessage = conversation.firstMessage;
        const historyItem = document.createElement('div');
        historyItem.className = 'history-item';
        historyItem.setAttribute('data-id', firstMessage.id);
        historyItem.setAttribute('data-conversation-id', conversation.conversationId);
        
        // Check if any message in this conversation was made in PRO mode
        const conversationMessages = conversationGroups[conversation.conversationId] || [];
        const hasProMode = conversationMessages.some(message => 
          message.entry.is_pro_mode === true
        );
        
        // Add 'pro-item' class if it's a PRO mode conversation
        if (hasProMode) {
          historyItem.classList.add('pro-item');
        }
        
        const messageCountBadge = conversation.messageCount > 1 
          ? `<span class="message-count">${conversation.messageCount}</span>` 
          : '';
        
        historyItem.innerHTML = `
          <div class="history-item-time">${formatTime(firstMessage.entry.timestamp)}</div>
          <div class="history-item-question">
            ${truncateText(firstMessage.entry.cleanQuestion || firstMessage.entry.question.replace(/^In the context of evidence law in the united states:\s*/i, ''), 60)}
            ${messageCountBadge}
          </div>
        `;
        
        historyItem.addEventListener('click', () => {
          // Remove active class from all items
          document.querySelectorAll('.history-item').forEach(item => {
            item.classList.remove('active');
          });
          
          // Add active class to clicked item
          historyItem.classList.add('active');
          
          // Display the conversation
          displayConversation(conversation.conversationId);
        });
        
        dateGroup.appendChild(historyItem);
      });
      
      historyList.appendChild(dateGroup);
    });
  }
  
  function displayConversation(conversationId) {
    // Find all messages in this conversation
    const conversationMessages = Object.keys(historyData)
      .filter(id => (historyData[id].conversation_id || id) === conversationId)
      .map(id => ({
        id: id,
        entry: historyData[id]
      }))
      .sort((a, b) => new Date(a.entry.timestamp) - new Date(b.entry.timestamp));
    
    if (conversationMessages.length === 0) return;
    
    currentConversationId = conversationId;
    
    const conversationContainer = document.getElementById('conversation-container');
    if (!conversationContainer) return;
    
    // Display all messages in the conversation
    const messagesHTML = conversationMessages.map(message => {
      const proModeBadge = message.entry.is_pro_mode === true ? 
        `<span class="pro-mode-badge">TA</span>` : '';
      
      return `
        <div class="conversation-message user-message">
          <div class="message-avatar">
            <i class="fas fa-user"></i>
          </div>
          <div class="message-content">
            <div class="message-text">${message.entry.cleanQuestion || message.entry.question.replace(/^In the context of evidence law in the united states:\s*/i, '')}</div>
            <div class="message-time">${formatTime(message.entry.timestamp)} ${proModeBadge}</div>
          </div>
        </div>
        
        <div class="conversation-message ai-message">
          <div class="message-avatar">
            <img src="/images/nunn-logo-150.png" alt="nunn.ai" class="ai-avatar">
          </div>
          <div class="message-content">
            <div class="message-text">${formatMarkdown(message.entry.response)}</div>
            <div class="message-time">${formatTime(message.entry.timestamp)}</div>
          </div>
        </div>
      `;
    }).join('');
    
    conversationContainer.innerHTML = `
      <div class="conversation-header">
        <h2 class="conversation-title">${formatDate(conversationMessages[0].entry.timestamp)}</h2>
        <div class="conversation-actions">
          <button class="conversation-action-btn" onclick="copyConversation('${conversationId}')">
            <i class="fas fa-copy"></i> Copy
          </button>
          <button class="conversation-action-btn" onclick="deleteConversation('${conversationId}')">
            <i class="fas fa-trash"></i> Delete
          </button>
        </div>
      </div>
      
      <div class="conversation-messages">
        ${messagesHTML}
      </div>
    `;
  }
  
  function copyConversation(conversationId) {
    // Find all messages in this conversation
    const conversationMessages = Object.keys(historyData)
      .filter(id => (historyData[id].conversation_id || id) === conversationId)
      .map(id => historyData[id])
      .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
    
    if (conversationMessages.length === 0) return;
    
    const text = conversationMessages.map(message => 
      `Q: ${message.question}\n\nA: ${message.response}`
    ).join('\n\n---\n\n');
    
    navigator.clipboard.writeText(text)
      .then(() => {
        // Show toast notification
        const toast = document.createElement('div');
        toast.className = 'history-toast';
        toast.innerHTML = '<i class="fas fa-check-circle"></i> Copied to clipboard!';
        document.body.appendChild(toast);
        
        // Remove toast after 3 seconds
        setTimeout(() => {
          toast.classList.add('fade-out');
          setTimeout(() => {
            document.body.removeChild(toast);
          }, 500);
        }, 3000);
      })
      .catch(err => {
        console.error('Could not copy text: ', err);
        alert('Failed to copy to clipboard');
      });
  }
  
  function deleteConversation(conversationId) {
    // Confirm deletion
    if (!confirm('Are you sure you want to delete this conversation? This action cannot be undone.')) {
      return;
    }
    
    // Call the API to delete the conversation
    fetch(`/api/history/delete/${encodeURIComponent(conversationId)}`, {
      method: 'DELETE',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      if (data.status === 'success') {
        // Show toast notification
        const toast = document.createElement('div');
        toast.className = 'history-toast';
        toast.innerHTML = '<i class="fas fa-check-circle"></i> Conversation deleted!';
        document.body.appendChild(toast);
        
        // Remove toast after 3 seconds
        setTimeout(() => {
          toast.classList.add('fade-out');
          setTimeout(() => {
            document.body.removeChild(toast);
          }, 500);
        }, 3000);
        
        // Remove conversation from history data
        Object.keys(historyData).forEach(id => {
          if ((historyData[id].conversation_id || id) === conversationId) {
            delete historyData[id];
          }
        });
        
        // Rerender history list
        renderHistoryList();
        
        // Show placeholder
        const conversationContainer = document.getElementById('conversation-container');
        if (conversationContainer) {
          conversationContainer.innerHTML = `
            <div class="conversation-placeholder">
              <i class="fas fa-history"></i>
              <h2>Your Conversation History</h2>
              <p>Select a conversation from the sidebar to view it here.</p>
            </div>
          `;
        }
      } else {
        alert('Failed to delete conversation: ' + data.message);
      }
    })
    .catch(error => {
      console.error('Error deleting conversation:', error);
      alert('Failed to delete conversation. Please try again later.');
    });
  }
  
  function continueConversation(conversationId) {
    // Close the modal
    const historyModal = document.getElementById('history-modal');
    historyModal.classList.remove('active');
    document.body.style.overflow = '';
    
    // Redirect to the main page with the conversation ID
    window.location.href = `/?conversation_id=${encodeURIComponent(conversationId)}`;
  }
  
  function truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }
  
  function formatDateHeader(dateStr) {
    const date = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString('en-US', { 
        weekday: 'long', 
        month: 'long', 
        day: 'numeric' 
      });
    }
  }
  
  function formatDate(timestamp) {
    if (!timestamp) return '';
    
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { 
      weekday: 'long', 
      month: 'long', 
      day: 'numeric',
      year: 'numeric'
    });
  }
  
  function formatTime(timestamp) {
    if (!timestamp) return '';
    
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
  }
  
  // Add the formatMarkdown function to handle markdown formatting in conversation responses
  function formatMarkdown(text) {
    if (!text) return '';
    
    // Handle headers
    text = text.replace(/^# (.*$)/gm, '<h1>$1</h1>');
    text = text.replace(/^## (.*$)/gm, '<h2>$1</h2>');
    text = text.replace(/^### (.*$)/gm, '<h3>$1</h3>');
    
    // Handle bold and italic
    text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');
    
    // Handle links - convert [text](url) to clickable span (no href prevents browser link preview)
    text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a data-href="$2" role="link" tabindex="0" class="citation-link" onclick="window.open(this.dataset.href,\'_blank\',\'noopener,noreferrer\');return false;">$1</a>');

    // Convert bare URLs to clickable links (no href prevents browser link preview)
    text = text.replace(
      /(^|\s|>)(https?:\/\/[^\s<]+)(?=$|\s|<)/g,
      '$1<a data-href="$2" role="link" tabindex="0" class="citation-link" onclick="window.open(this.dataset.href,\'_blank\',\'noopener,noreferrer\');return false;">$2</a>'
    );
    
    // Handle code blocks and inline code
    text = text.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');
    text = text.replace(/`([^`]+)`/g, '<code>$1</code>');
    
    // Handle line breaks
    text = text.replace(/\n/g, '<br>');
    
    return text;
  }
  
  function filterHistoryList(searchTerm) {
    // Get all history items
    const historyItems = document.querySelectorAll('.history-item');
    let visibleItemsCount = 0;
    
    // Loop through each item and check if it matches the search term
    historyItems.forEach(item => {
      const id = item.getAttribute('data-id');
      const entry = historyData[id];
      
      if (!entry) return;
      
      const questionText = entry.question.toLowerCase();
      const responseText = entry.response.toLowerCase();
      
      // Show item if question or response contains the search term
      if (questionText.includes(searchTerm) || responseText.includes(searchTerm)) {
        item.style.display = 'block';
        visibleItemsCount++;
      } else {
        item.style.display = 'none';
      }
    });
    
    // Show or hide date headers based on visible items
    const dateGroups = document.querySelectorAll('.history-date-group');
    dateGroups.forEach(group => {
      const items = group.querySelectorAll('.history-item');
      let hasVisibleItems = false;
      
      items.forEach(item => {
        if (item.style.display !== 'none') {
          hasVisibleItems = true;
        }
      });
      
      // Show or hide the date header based on visible items
      const dateHeader = group.querySelector('.history-date-header');
      if (dateHeader) {
        dateHeader.style.display = hasVisibleItems ? 'block' : 'none';
      }
    });
    
    // Show a message if no results found
    const historyList = document.getElementById('history-list');
    const noResultsMessage = historyList.querySelector('.no-results-message');
    
    if (visibleItemsCount === 0 && searchTerm !== '') {
      if (!noResultsMessage) {
        const message = document.createElement('div');
        message.className = 'no-results-message';
        message.innerHTML = `
          <div class="history-empty">
            <i class="fas fa-search"></i>
            <p>No results found for "${searchTerm}"</p>
          </div>
        `;
        historyList.appendChild(message);
      }
    } else if (noResultsMessage) {
      historyList.removeChild(noResultsMessage);
    }
  }
  
  // Process history data for recent activity section
  function processRecentActivity() {
    return new Promise((resolve, reject) => {
      const recentActivityList = document.getElementById('recent-activity-list');
      if (!recentActivityList) {
        reject("Recent activity list element not found");
        return;
      }
      
      // Clear any existing loading state
      recentActivityList.innerHTML = `
        <div class="activity-loading">
          <i class="fas fa-spinner fa-spin"></i>
          <p>Loading activity...</p>
        </div>
      `;
      
      // If the activity has already been processed and we have history data,
      // just render the activity again rather than returning early
      if (window.recentActivityProcessed && window.historyData && Object.keys(window.historyData).length > 0) {
        renderRecentActivity(window.historyData);
        resolve(window.historyData);
        return;
      }
      
      // If we already have history data loaded but not processed, use it
      if (window.historyData && Object.keys(window.historyData).length > 0) {
        renderRecentActivity(window.historyData);
        window.recentActivityProcessed = true;
        resolve(window.historyData);
        return;
      }
      
      // Otherwise fetch history data
      fetch('/api/history')
        .then(response => response.json())
        .then(data => {
          window.historyData = data;
          renderRecentActivity(data);
          window.recentActivityProcessed = true;
          // Set historyDataLoaded to true so that the history modal knows data is already loaded
          window.historyDataLoaded = true;
          resolve(data);
        })
        .catch(error => {
          console.error('Error loading recent activity data:', error);
          recentActivityList.innerHTML = `
            <div class="activity-empty">
              <i class="fas fa-exclamation-circle"></i>
              <p>Unable to load activity. Please try again later.</p>
            </div>
          `;
          reject(error);
        });
    });
  }
  
  // Render recent activity from history data
  function renderRecentActivity(historyData) {
    const recentActivityList = document.getElementById('recent-activity-list');
    if (!recentActivityList) return;
    
    // Clear existing content
    recentActivityList.innerHTML = '';
    
    // Check if we have any history data
    if (!historyData || Object.keys(historyData).length === 0) {
      recentActivityList.innerHTML = `
        <div class="activity-empty">
          <i class="fas fa-search"></i>
          <p>You haven't asked any questions yet.</p>
          <a href="/" class="start-asking-btn">Start Asking</a>
        </div>
      `;
      return;
    }
    
    // Group by conversation_id
    const conversationGroups = {};
    Object.keys(historyData).forEach(id => {
      const entry = historyData[id];
      const conversationId = entry.conversation_id || id;
      
      if (!conversationGroups[conversationId]) {
        conversationGroups[conversationId] = [];
      }
      conversationGroups[conversationId].push({
        id: id,
        entry: entry
      });
    });
    
    // Sort messages within each conversation by timestamp
    Object.keys(conversationGroups).forEach(conversationId => {
      conversationGroups[conversationId].sort((a, b) => {
        return new Date(a.entry.timestamp) - new Date(b.entry.timestamp);
      });
    });
    
    // Sort conversations by recency (using the latest message in each conversation)
    const sortedConversations = Object.keys(conversationGroups)
      .map(convId => conversationGroups[convId])
      .sort((a, b) => {
        const aLatest = a[a.length - 1];
        const bLatest = b[b.length - 1];
        return new Date(bLatest.entry.timestamp) - new Date(aLatest.entry.timestamp);
      });
    
    // Get the 3 most recent conversations
    const recentConversations = sortedConversations.slice(0, 3);
    
    // Clear existing content
    recentActivityList.innerHTML = '';
    
    // Display recent conversations
    recentConversations.forEach(conversation => {
      // Get the first message (chronologically) in the conversation
      const firstMessage = conversation[0];
      
      // Check if any message in this conversation was made in PRO mode
      const hasProMode = conversation.some(message => 
        message.entry.is_pro_mode === true
      );
      
      const activityItem = document.createElement('div');
      activityItem.className = `activity-item ${hasProMode ? 'pro-item' : ''}`;
      activityItem.setAttribute('data-conversation-id', firstMessage.entry.conversation_id || firstMessage.id);
      activityItem.addEventListener('click', () => {
        openHistoryModalWithConversation(firstMessage.entry.conversation_id || firstMessage.id);
      });
      
      // Clean the question text (remove prefix if present)
      const cleanQuestion = firstMessage.entry.question.replace(/^In the context of evidence law in the united states:\s*/i, '');
      
      activityItem.innerHTML = `
        <div class="activity-icon">
          <i class="fas fa-comment-alt"></i>
        </div>
        <div class="activity-content">
          <p class="activity-text">${truncateText(cleanQuestion, 60)}</p>
          <p class="activity-time">
            ${formatTime(firstMessage.entry.timestamp)}
            ${conversation.length > 1 ? `<span class="message-count">${conversation.length}</span>` : ''}
          </p>
        </div>
      `;
      
      recentActivityList.appendChild(activityItem);
    });
  }
  
  // Initialize recent activity when the dashboard modal is opened
  if (window.dashboardLink) {
    window.dashboardLink.addEventListener('click', function(e) {
      if (!window.recentActivityProcessed) {
        setTimeout(processRecentActivity, 100); // Process after modal is displayed
      }
    });
  }
  
  // Helper function to truncate text
  function truncateText(text, maxLength) {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }
  
  // Format timestamp for display
  function formatTime(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  
  // Social login modal functionality
  const changePasswordBtn = document.getElementById('change-password-btn');
  const socialLoginModal = document.getElementById('social-login-modal');
  const closeSocialLoginModal = document.getElementById('close-social-login-modal');
  const socialLoginOkBtn = document.getElementById('social-login-ok-btn');
  const socialLoginOverlay = socialLoginModal ? socialLoginModal.querySelector('.modal-overlay') : null;
  
  if (changePasswordBtn) {
    changePasswordBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Check if user uses social login via AJAX
      fetch('/change-password')
        .then(response => response.json().catch(() => null))
        .then(data => {
          if (data && data.is_social_login) {
            // User has social login, show the modal with the appropriate message
            document.getElementById('social-login-message').textContent = data.message;
            socialLoginModal.classList.add('active');
            document.body.style.overflow = 'hidden'; // Prevent scrolling
          } else {
            // Regular user, redirect to change password
            window.location.href = '/change-password';
          }
        })
        .catch(error => {
          console.error('Error checking password change:', error);
          // Fall back to regular redirect in case of error
          window.location.href = '/change-password';
        });
    });
  }
  
  // Close social login modal when X button is clicked
  if (closeSocialLoginModal) {
    closeSocialLoginModal.addEventListener('click', function() {
      socialLoginModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });
  }
  
  // Close social login modal when OK button is clicked
  if (socialLoginOkBtn) {
    socialLoginOkBtn.addEventListener('click', function() {
      socialLoginModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });
  }
  
  // Close social login modal when clicking on overlay
  if (socialLoginOverlay) {
    socialLoginOverlay.addEventListener('click', function() {
      socialLoginModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });
  }
  
  // Close social login modal with Escape key
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && socialLoginModal && socialLoginModal.classList.contains('active')) {
      socialLoginModal.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    }
  });
  
  // Make copy and continue conversation functions globally available
  window.copyConversation = copyConversation;
  window.continueConversation = continueConversation;
  window.deleteConversation = deleteConversation;

  // --- NEW: Handle click on the main upgrade button inside the modal ---
  // We need to wait for the modal content to potentially load, so delegate
  document.body.addEventListener('click', function(e) {
    // Check if the clicked element is the upgrade button inside the modal
    const modalUpgradeButton = e.target.closest('#modal-upgrade-button'); // Use closest to handle clicks on icons inside the button

    if (modalUpgradeButton && upgradeModal.classList.contains('active')) {
      e.preventDefault(); // Prevent default link behavior

      // Read data attributes from the button
      const isAuthenticated = modalUpgradeButton.getAttribute('data-is-authenticated') === 'true';
      const stripeUrl = modalUpgradeButton.getAttribute('data-stripe-url');
      const loginUrl = modalUpgradeButton.getAttribute('data-login-url');

      console.log(`Upgrade button clicked. Authenticated: ${isAuthenticated}, Stripe URL: ${stripeUrl}, Login URL: ${loginUrl}`); // Debug log

      if (isAuthenticated) {
        // Logged in: proceed to Stripe
        if (stripeUrl && stripeUrl !== '#') {
          // --- START FIX ---
          const userId = modalUpgradeButton.getAttribute('data-user-id');
          let finalStripeUrl = stripeUrl;
          if (userId) {
            // Append client_reference_id, handling existing query parameters if any
            const separator = finalStripeUrl.includes('?') ? '&' : '?';
            finalStripeUrl += `${separator}client_reference_id=${encodeURIComponent(userId)}`;
          }
          console.log('User authenticated, redirecting to Stripe:', finalStripeUrl);
          window.location.href = finalStripeUrl;
          // --- END FIX ---
        } else {
          console.error('Stripe URL not found or invalid for authenticated user.');
          alert('Error: Could not initiate upgrade. Please try again later.');
        }
      } else {
        // Anonymous: redirect to login
        if (loginUrl) {
          console.log('User not authenticated, redirecting to login:', loginUrl);
          window.location.href = loginUrl;
        } else {
          console.error('Login URL not found for anonymous user.');
          // Fallback or show error
          alert('Error: Please log in or sign up to upgrade.');
          // Or redirect to a generic login page if loginUrl is missing for some reason
          // window.location.href = '/login';
        }
      }
    }
  });
  // --- END NEW ---

});
